/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './treatment-regimen-investigation-obs.reducer';

export const TreatmentRegimenInvestigationObsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const treatmentRegimenInvestigationObsEntity = useAppSelector(state => state.treatmentRegimenInvestigationObs.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="treatmentRegimenInvestigationObsDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.treatmentRegimenInvestigationObs.detail.title">
            TreatmentRegimenInvestigationObs
          </Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.treatmentRegimenInvestigationObs.id">Id</Translate>
            </span>
          </dt>
          <dd>{treatmentRegimenInvestigationObsEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.treatmentRegimenInvestigationObs.active">Active</Translate>
            </span>
          </dt>
          <dd>{treatmentRegimenInvestigationObsEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.treatmentRegimenInvestigationObs.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{treatmentRegimenInvestigationObsEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.treatmentRegimenInvestigationObs.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{treatmentRegimenInvestigationObsEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.treatmentRegimenInvestigationObs.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{treatmentRegimenInvestigationObsEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.treatmentRegimenInvestigationObs.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{treatmentRegimenInvestigationObsEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentRegimenInvestigationObs.regimenInvestigation">Regimen Investigation</Translate>
          </dt>
          <dd>
            {treatmentRegimenInvestigationObsEntity.regimenInvestigation
              ? treatmentRegimenInvestigationObsEntity.regimenInvestigation.id
              : ''}
          </dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentRegimenInvestigationObs.imageStudy">Image Study</Translate>
          </dt>
          <dd>{treatmentRegimenInvestigationObsEntity.imageStudy ? treatmentRegimenInvestigationObsEntity.imageStudy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentRegimenInvestigationObs.panel">Panel</Translate>
          </dt>
          <dd>{treatmentRegimenInvestigationObsEntity.panel ? treatmentRegimenInvestigationObsEntity.panel.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentRegimenInvestigationObs.panelItem">Panel Item</Translate>
          </dt>
          <dd>{treatmentRegimenInvestigationObsEntity.panelItem ? treatmentRegimenInvestigationObsEntity.panelItem.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentRegimenInvestigationObs.labTestItemResult">Lab Test Item Result</Translate>
          </dt>
          <dd>
            {treatmentRegimenInvestigationObsEntity.labTestItemResult ? treatmentRegimenInvestigationObsEntity.labTestItemResult.id : ''}
          </dd>
        </dl>
        <Button tag={Link} to="/treatment-regimen-investigation-obs" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button
          tag={Link}
          to={`/treatment-regimen-investigation-obs/${treatmentRegimenInvestigationObsEntity.id}/edit`}
          replace
          color="primary"
        >
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TreatmentRegimenInvestigationObsDetail;
